import React from 'react';

import {Link} from 'react-router';

import {UserAvatar} from 'app/components/general/avatars';
import {getUserDetailPageURL} from 'app/urls';
import {gt} from 'app/utils/i18n';

import {DateText, FixableHeader, FixableTable} from './utils';

import type {
  BasicTeamSerializedType,
  DocTaskReportItemType,
  ReportResultSerializedType,
} from 'sweet-types';

interface Props {
  result: ReportResultSerializedType<
    DocTaskReportItemType & {teams_managed: Array<BasicTeamSerializedType>}
  >;
}

export function RenderTeammateTeamSummary({result}: Props): JSX.Element {
  return (
    <FixableTable>
      <thead>
        <tr>
          <FixableHeader>{gt('Name')}</FixableHeader>
          <FixableHeader>{gt('Email')}</FixableHeader>
          <FixableHeader>{gt('Date Joined')}</FixableHeader>
          <FixableHeader>{gt('Last Seen At')}</FixableHeader>
          <FixableHeader textAlign="center">
            {gt('Number of Sessions')}
          </FixableHeader>
          <FixableHeader>{gt('Teams')}</FixableHeader>
          <FixableHeader>{gt('Team Managed')}</FixableHeader>
          <FixableHeader>{gt('Super Teammate')}</FixableHeader>
          <FixableHeader>{gt('Super Manager')}</FixableHeader>
          <FixableHeader textAlign="center">
            {gt('Billing Active?')}
          </FixableHeader>
        </tr>
      </thead>
      <tbody>
        {result.results.map((r, i) => (
          <tr key={i}>
            <td>
              <div className="d-flex align-items-center">
                <UserAvatar user={r['user']} small showCard className="mr-2" />
                <Link
                  to={getUserDetailPageURL(r['user']['id'])}
                  className="font-weight-bold"
                >
                  {r['user']['name']}
                </Link>
              </div>
            </td>
            <td>
              <div className="d-flex align-items-center">
                {r['user']['email']}
              </div>
            </td>
            <td>
              <DateText>{r['date_joined']}</DateText>
            </td>
            <td>
              {r['last_seen_at'] != null ? (
                <DateText>{r['last_seen_at']}</DateText>
              ) : (
                gt('Never Logged In')
              )}
            </td>
            <td className="text-right pr-5">{r['sessions']}</td>
            <td>
              <ul className="mb-0 pl-4">
                {r.teams.map((t) => (
                  <li key={t.html_url}>
                    <Link to={t.html_url}>{t.name}</Link>
                  </li>
                ))}
              </ul>
            </td>
            <td>
              <ul className="mb-0 pl-4">
                {r.teams_managed.map((t) => (
                  <li key={t.html_url}>
                    <Link to={t.html_url}>{t.name}</Link>
                  </li>
                ))}
              </ul>
            </td>
            <td className="text-center">
              {r['is_super_teammate'] === true ? gt('Yes') : gt('No')}
            </td>
            <td className="text-center">
              {r['is_super_manager'] === true ? gt('Yes') : gt('No')}
            </td>
            <td className="text-center">
              {r['billing_active'] === true ? gt('Yes') : gt('No')}
            </td>
          </tr>
        ))}
      </tbody>
    </FixableTable>
  );
}
